import yoflags from '@yola/yoflagsjs';
import yousersjs from '@yola/yousersjs';
import config from '../helpers/config';

const DIFM_BANNER_FEATURE = 'nn_difm_promo';
const activeSubscriptionStatuses = ['active', 'canceled', 'expired', 'frozen'];

async function isDifmEnabled(isUserAuthenticated) {
  const apiUrl = config.get('publicApi');

  let isFeatureEnabled = false;

  try {
    const { visitorFlags, userFlags } = await yoflags.initWith(apiUrl);

    if (isUserAuthenticated) {
      // as we use http protocol to run yolacom localy this request
      // does not work localy because of Yola cookie Secure
      const {
        data: {
          data: { [DIFM_BANNER_FEATURE]: featureFlag },
        },
      } = await userFlags(DIFM_BANNER_FEATURE);

      isFeatureEnabled = featureFlag || false;
    } else {
      const { data } = await visitorFlags();

      isFeatureEnabled = data[DIFM_BANNER_FEATURE] || false;
    }
  } catch (error) {
    console.error(error);
  }

  return isFeatureEnabled;
}

async function isDifmOrderSubmitted(isUserAuthenticated) {
  try {
    if (!isUserAuthenticated) {
      return false;
    }

    const response = await yousersjs.preferences().get();
    const { body } = response;

    return body.difm_order_submitted === 'True';
  } catch (error) {
    console.error(error);
    return true;
  }
}

function showDifmTopBanner({ upgrade } = {}) {
  const difmBannerTemplate = document.getElementById('difm-banner');
  const difmBanner = document.importNode(difmBannerTemplate.content, true);
  const pageContent = document.getElementById('page-content');
  const actionToRemove = upgrade ? 'get-started' : 'upgrade';
  const difmBannerRoot = difmBanner.querySelector('.ws-difm-banner');

  difmBannerRoot.addEventListener('click', (e) => {
    const { href } = e.currentTarget.dataset;

    if (href) {
      window.location.href = href;
    }
  });
  difmBanner.querySelector(`[data-cta-action='${actionToRemove}']`).remove();
  pageContent.prepend(difmBanner);
  difmBannerTemplate.remove();
}

function showDifmPromo({ upgrade } = {}) {
  const difmPromoTemplate = document.getElementById('difm-promo');
  const difmPromo = document.importNode(difmPromoTemplate.content, true);
  const paywallContainer = document.querySelector('.paywall-container');
  const paywallSection = paywallContainer.parentElement;
  const pageContent = document.getElementById('page-content');
  const actionToRemove = upgrade ? 'get-started' : 'upgrade';

  difmPromo.querySelector(`[data-cta-action='${actionToRemove}']`).remove();

  const difmPromoSticky = difmPromo.cloneNode(true);

  difmPromo.querySelector('.ws-difm-promo').classList.add('ws-difm-promo--static');
  difmPromoSticky.querySelector('.ws-difm-promo').classList.add('ws-difm-promo--sticky');
  paywallSection.classList.add('with-difm-promo');

  paywallSection.insertAdjacentElement(
    'afterend',
    difmPromo.firstElementChild
  );
  pageContent.insertAdjacentElement(
    'beforeend',
    difmPromoSticky.firstElementChild
  );

  const staticElement = document.querySelector('.ws-difm-promo--static');
  const stickyElement = document.querySelector('.ws-difm-promo--sticky');

  const observerOptions = {
    root: null, // Use viewport as root
    rootMargin: '0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === staticElement) {
        if (entry.isIntersecting) {
          // Static element is visible, hide sticky
          staticElement.classList.add('ws-difm-promo--visible');
          stickyElement.classList.add('ws-difm-promo--hidden');
        } else {
          // Static element is not visible, show sticky
          staticElement.classList.remove('ws-difm-promo--visible');
          stickyElement.classList.remove('ws-difm-promo--hidden');
        }
      }
    });
  }, observerOptions);

  observer.observe(staticElement);

  difmPromoTemplate.remove();
}

function showDifmBadge() {
  const difmOfferElements = document.querySelectorAll('.ws-difm-offer');
  const difmBadgeTemplate = document.getElementById('difm-badge');
  const difmBadge = document.importNode(difmBadgeTemplate.content, true);

  difmOfferElements.forEach((offerElement) => {
    offerElement.parentElement.classList.add('ws-difm-plan');
    offerElement.parentElement.prepend(difmBadge.cloneNode(true));
    offerElement.classList.add('ws-difm-offer--visible');
  });

  difmBadgeTemplate.remove();
}

function addDifmPromoCampaing() {
  const goldPlanLinks = document.querySelectorAll('[data-difm-href]');

  goldPlanLinks.forEach((goldPlanLink) => {
    const urlObject = new URL(goldPlanLink.getAttribute('href'));

    urlObject.searchParams.set('promo_campaign_id', 'difm-promo');
    goldPlanLink.setAttribute('href', urlObject.href);
  });
}

async function showDifmBanners({ subscriptions, isUserAuthenticated } = {}) {
  const hasGoldSubscription = subscriptions?.some((sub) => sub.type === 'gold' && activeSubscriptionStatuses.includes(sub.status));

  if (hasGoldSubscription) {
    return;
  }

  const [isFeatureEnabled, isDifmSubmitted] = await Promise.all([
    isDifmEnabled(isUserAuthenticated),
    isDifmOrderSubmitted(isUserAuthenticated)
  ]);

  if (!isFeatureEnabled || isDifmSubmitted) {
    return;
  }

  const upgrade = isUserAuthenticated;

  addDifmPromoCampaing();
  showDifmTopBanner({ upgrade });
  showDifmPromo({ upgrade });
  showDifmBadge();
}

export default showDifmBanners;
